<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <h4>List of Sales Forcast</h4>

        <Toolbar class="p-mb-4">
          <template slot="left">
            <span class="p-input-icon-left">
              <div class="p-inputgroup">
                <Button
                  icon="pi pi-fw pi-refresh"
                  class="p-mr-1"
                  @click="setupComponentData(1)"
                />
                <InputText
                  v-model="searchText"
                  placeholder="Global Search"
                  @input="updateSearch"
                />
                <Button
                  icon="pi pi-times p-pr-1"
                  class="p-mr-1"
                  @click="closeSearch"
                />
                <div
                  :class="getClassForQuickFiltersDiv()"
                  :key="quickFiltersDivKey"
                >
                  <Button
                    style="width: 50px; top: 50%; transform: translate(0%, -50%);"
                    @click="
                      quickFilterDialog = true;
                      quickFilterDialogKey++;
                    "
                    icon="pi pi-filter"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                    :badge="getBadgeForQuickFilters().toString()"
                  />
                  <Button
                    v-if="isEmpty()"
                    @click="clearQuickFilter()"
                    icon="pi pi-times"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                  />
                </div>
              </div>
            </span>
          </template>
          <template slot="right">
            <div class="p-inputgroup">
              <Button
                label="Delete selected rows"
                class="p-button-danger mr-1"
                icon="pi pi-trash"
                @click="deleteRecordsConfirmation"
                iconPos="right"
                :disabled="!(selectedRows && selectedRows.length)"
              />
              <Button
                label="Add file"
                class="p-button-info"
                icon="pi pi-plus"
                @click="$refs.file.click()"
                iconPos="right"
                :disabled="
                  $store.getters['salesForecast/getSalesForecastPosting']
                "
              />
              <input
                single
                type="file"
                ref="file"
                style="display: none;"
                accept="text/plain, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="onFileSelect"
                :disabled="
                  $store.getters['salesForecast/getSalesForecastPosting']
                "
              />
            </div>
          </template>
        </Toolbar>
      </div>
    </div>

    <ProgressSpinner
      v-if="firstRequesting"
      style="width:50px; height:50px;"
      strokeWidth="5"
      fill="#EEEEEE"
      animationDuration=".5s"
    />
    <div v-else style="width: 100%;">
      <component
        :is="tableComponent"
        :sales="customers"
        :requesting="requesting"
        :filters="filters"
        :loading="loading"
        :dbViewFields="dbViewFields"
        :colSelectedFields="colSelectedFields"
        :colSelectedFieldsForTable="colSelectedFieldsForTable"
        :totalRecords="totalRecords"
        :rows="rows"
        :currentPage="currentPage"
        :reloadTable="realoadLazyTable"
        @reload="reload"
        @lazyNext="lazyNext"
        @sortChange="sortChange"
        @selected-records="setSelectedRows"
      />
    </div>

    <Dialog
      header="Success"
      :visible.sync="postingInfo"
      :style="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span
          >Processing File… Please visit this page again to check the progress
          at the bottom.</span
        >
      </div>
      <template #footer>
        <Button
          label="Ok"
          icon="pi pi-check"
          @click="postingInfo = false"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <div
      v-if="posting || (postingErrors && postingErrors.length)"
      id="progressDiv"
    >
      <div id="progressDetails">
        <div v-if="posting">
          <ProgressBar :value="postProgress" style="height: 0.3rem" />
          <span>{{ postProgress }}%</span>
          <br />
          <span
            >Posted: {{ postedRecords }}, Total: {{ postingTotalRecords }},
            Errors:
            {{
              failedRecords && failedRecords[0] ? failedRecords.length : 0
            }}</span
          >
        </div>
        <div v-else-if="postingErrors && postingErrors.length">
          <span
            >There were {{ postingErrors.length }} in the last posting.</span
          >
          <br />
          <span
            class="errorSpan errorPointer pr-3"
            @click="displayPostingErrors = true"
          >
            View Errors
          </span>
          <span
            class="errorSpan errorPointer pr-3"
            @click="$store.dispatch('salesForecast/addActualSalesErrors')"
          >
            Close Errors
          </span>
        </div>
      </div>
      <!-- <div id="crossButton">
        <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text" />
      </div> -->
    </div>

    <ErrorsMessageDialog
      :viewDialog="displayPostingErrors"
      :messages="postingErrors"
      @close="displayPostingErrors = false"
      @clearAllErrors="
        displayPostingErrors = false;
        $store.dispatch('actualSales/addActualSalesErrors');
      "
    />

    <Dialog
      :key="quickFilterDialogKey"
      :visible.sync="quickFilterDialog"
      :style="{ width: '500px', overflowY: 'auto' }"
      header="Quick Filters"
      :modal="true"
      class="p-fluid"
    >
      <div v-for="(element, index) in dbViewFieldsForQuickFilters" :key="index">
        <div v-if="element.quickFilter === true" class="p-formgrid p-grid">
          <div class="p-field p-col p-d-flex">
            <label class="p-as-center" :for="element.fieldName">
              {{ element.fieldName }}
            </label>
          </div>
          <div class="p-field p-col">
            <div v-if="isQuickFilterable(index)">
              <div v-if="getFieldType(index) === 'Date'" style="width: 250px;">
                <Dropdown
                  :showClear="true"
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  optionLabel="dateModifierName"
                  dataKey="id"
                  placeholder="Select from the dropdown"
                  style="width: 100%"
                />
                <div class="pt-1">
                  <InputMask
                    v-if="showDateRanges(index)"
                    mask="99/99/9999"
                    v-model="datesFrom[index]"
                    slotChar="dd/mm/yyyy"
                    placeholder="Date from"
                    style="width: 49%;"
                  />
                  <InputMask
                    v-if="showDateRanges(index)"
                    mask="99/99/9999"
                    v-model="datesTo[index]"
                    slotChar="dd/mm/yyyy"
                    placeholder="Date to"
                    style="width: 49%; float: right;"
                  />
                </div>
              </div>
              <div
                v-else-if="getFieldType(index) === 'Currency'"
                style="width: 250px;"
              >
                £
                <InputNumber
                  v-model="datesFrom[index]"
                  placeholder="From"
                  style="width: 45%;"
                />
                £
                <InputNumber
                  v-model="datesTo[index]"
                  placeholder="To"
                  style="width: 45%; float: right;"
                />
              </div>
              <div
                v-else-if="getFieldType(index) === 'Number'"
                style="width: 250px;"
              >
                <InputNumber
                  v-model="datesFrom[index]"
                  placeholder="From"
                  style="width: 49%;"
                />
                <InputNumber
                  v-model="datesTo[index]"
                  placeholder="To"
                  style="width: 49%; float: right;"
                />
              </div>
              <div v-else style="width: 250px">
                <CustomDropDown
                  v-if="useAutoComplete(index)"
                  :allOptions="getOptions(index)"
                  :disabled="false"
                  :optionLabel="getOptionLabel(element, index)"
                  :dataKey="getDataKey(element)"
                  :forceSelection="isForceSelection(index)"
                  :showDropDownOnStart="showDropdown(index)"
                  :index="index"
                  :useCustomID="true"
                  :currentValue="quickFiltersSelection[index]"
                  placeholder="Type to display options"
                  style="width: 100%"
                  @selected="setSelection"
                >
                </CustomDropDown>
                <Dropdown
                  v-else
                  :showClear="true"
                  v-model="quickFiltersSelection[index]"
                  :options="getOptions(index)"
                  :optionLabel="getOptionLabel(element, index)"
                  :dataKey="getDataKey(element)"
                  placeholder="Select from the dropdown"
                  style="width: 100%"
                />
              </div>
            </div>
            <ProgressSpinner
              v-else
              style="width:30px; height:30px"
              strokeWidth="2"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          style="float: left;"
          label="Clear All Filters"
          icon="pi pi-times"
          class="p-button-danger"
          @click="clearQuickFilter()"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-info"
          style="width: 100px;"
          @click="quickFilterDialog = false"
        />
        <Button
          label="Apply Filters"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 130px;"
          @click="setupQuickFilter()"
        />
      </template>
    </Dialog>

    <Dialog header="Header" :visible.sync="deleteRecordWarning">
      <template #header>
        <h3>Delete Alert</h3>
      </template>

      Are you sure you want to delete this record?

      <template #footer>
        <Button
          @click="deleteRecordWarning = false"
          label="No"
          icon="pi pi-times"
          class="p-button-success"
          style="width: 80px;"
        />
        <ProgressSpinner
          v-if="deleteRequesting"
          style="width:25px; height:25px; width: 80px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          @click="deleteRecords()"
          label="Yes"
          icon="pi pi-check"
          autofocus
          class="p-button-danger"
          style="width: 80px;"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
// import CustomerService from "@/service/CustomerService";
import FiltersService from "@/service/FiltersSerice";

// import CustomerDataTableForLazy from '../universalComponents/customer/CustomersDataTableForLazyWithResize'
// import ColumnSelection from '../universalComponents/columnSelection/ColumnSelection'
// import FilterForm from '../universalComponents/filter/filterForm'
// import customerForm from '../universalComponents/customer/customerForm'
// import duplicateTable from '../universalComponents/customer/duplicateDialog'

// import moment from 'moment'

// import {
//   customerConf
// } from '../universalComponents/sendRequest'

import SalesService from "@/service/SalesService";

import SalesForcastTableForLazyLoadingWithResize from "../universalComponents/salesForcast/SalesForcastTableForLazyLoadingWithResize.vue";
import ErrorsMessageDialog from "../universalComponents/ErrorsMessageDialog";

import readXlsxFile from "read-excel-file";

export default {
  components: {
    SalesForcastTableForLazyLoadingWithResize,
    // CustomerDataTableForLazy,
    // ColumnSelection,
    // FilterForm,
    // customerForm,
    // duplicateTable,
    ErrorsMessageDialog
  },
  created() {
    this.setupComponent();
  },
  data: () => ({
    // customerService: new CustomerService(),
    filtersService: new FiltersService(),
    salesService: new SalesService(),

    dbView: 11, // 11 for sales forcast
    filterFormDialog: false,
    savedFilters: null,
    savedFilter: null,
    customers: [], // For whole data set
    customer: {},
    customerDialog: false,
    displayDuplicateMessage: false,
    duplicateInfo: {},
    messages: [],
    dbViewFields: [],
    dbViewFieldsForQuickFilters: [],
    quickFiltersSelection: [],
    datesFrom: [],
    datesTo: [],
    quickFiltersOptions: [],
    tableKey1: 0,
    disabledArr: [],
    columnSelectionDialog: false,
    defaultView: true,
    colSelectedFields: [],
    colSelectedFieldsForTable: [],
    requesting: false,
    tableKey1: 0,
    realoadLazyTable1: 0,
    deleteSavedFilterWarning: false,
    quickFilterDialogKey1: 0,
    quickFilterDialog: false,
    filterToEdit: {},
    duplicates: [],
    displayDuplicateMessage: false,
    quickFiltersDivKey1: 0,
    reloadColumnSelectionComponent: 0,
    resettingColumns: false,
    deleteRequesting: false,
    favoriteRequesting: false,
    favorite: false,

    searchText: "",
    totalRecords: null,
    totalPages: null,
    currentPage: 1,
    rows: 25,
    sortField: "",
    sortFieldId: 0,
    sortOrder: 0,
    lastMainRequestBody: {},
    lastMainRequest: "",
    firstRequesting: true,
    forceReload: false,
    duplicateRequesting: false,

    sendingRequest: false,
    submitted: false,
    deleteRecordWarning: false,
    selectedRows: [],

    makingExport: false,

    filters: {},

    postingInfo: false,
    displayPostingErrors: false
  }),
  computed: {
    // hardLoad() {
    //   return this.$store.getters['customers/getHardLoad']
    // },
    // softReload() {
    //   return this.$store.getters['customers/getSoftReload']
    // },
    realoadLazyTable: {
      set() {
        this.tableKey1++;
      },
      get() {
        return "realoadLazyTable-" + this.tableKey1.toString();
      }
    },
    loading() {
      //
      if (this.customers && this.customers[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    tableComponent() {
      return this.firstRequesting === false
        ? SalesForcastTableForLazyLoadingWithResize
        : null;
    },
    formComponent() {
      return this.firstRequesting === false || this.customerDialog
        ? customerForm
        : null;
    },
    quickFilterDialogKey: {
      set() {
        this.quickFilterDialogKey1++;
      },
      get() {
        return "quickFilterDialogKey-" + this.quickFilterDialogKey1.toString();
      }
    },
    quickFiltersDivKey: {
      set(val) {
        this.quickFiltersDivKey1++;
      },
      get() {
        return "quickFiltersDivKey" + this.quickFiltersDivKey1.toString();
      }
    },

    postingErrors() {
      return this.$store.getters["salesForecast/getSalesForecastErrors"];
    },
    posting() {
      return this.$store.getters["salesForecast/getSalesForecastPosting"];
    },
    failedRecords() {
      return this.$store.getters["salesForecast/getSalesForecastErrors"];
    },
    postedRecords() {
      return this.$store.getters["salesForecast/getSalesForecastPosted"];
    },
    postingTotalRecords() {
      return this.$store.getters["salesForecast/getSalesForecastTotals"];
    },
    postProgress() {
      let a = (this.postedRecords / this.postingTotalRecords) * 100;
      if (a) {
        return parseFloat(a.toFixed(2));
      } else {
        return 0;
      }
    }
  },
  watch: {
    currentPage(val) {
      //
      // this.$store.dispatch('customers/setPage', { page: val, rows: this.$store.getters['customers/getRows'] })

      if (val === 1) {
        this.realoadLazyTable++;
      }
    },
    // hardLoad(val) {
    //   //

    //   this.setupComponentData(1)
    // },
    // softReload(val) {
    //   //

    //   this.setupComponentData(0)
    // },
    colSelectedFields(val) {
      // this.$store.dispatch(`commons/columnsSelection${this.dbView}`, val)
      this.setupColumns();
    },
    colSelectedFieldsForTable(val) {
      //
      // this.realoadLazyTable++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a =>
    },
    savedFilter(val) {
      // if (val && (val.favourite !== null || val.favourite !== undefined)) {
      //   this.favorite = val.favourite
      // }
      // let oldFilter = this.$store.getters['customers/getMainListSavedFilter']
      // this.$store.dispatch('customers/setMainListSavedFilter', val)
      // if (!(oldFilter && val && oldFilter.id === val.id)) {
      //   this.currentPage = 1
      // }
      // this.getDataFromSource()
    },
    dbViewFieldsForQuickFilters(val) {
      //
      if (
        !this.quickFiltersSelection.every(
          element => element === undefined || element === null
        )
      ) {
        this.getDataFromSource();
      }
    },
    dbViewFields(val) {
      this.setupViewFieldsForQuickFilters();

      //
      if (this.colSelectedFieldsForTable.length < 1) {
        this.colSelectedFieldsForTable = val.filter(a => a.defView);
      }
      // this.colSelectedFieldsForTable.forEach(a =>
    },
    quickFiltersSelection(val) {
      //
      this.$store.dispatch("salesForecast/setMainListQuickFilters", val);
    },
    datesFrom(val) {
      this.$store.dispatch("salesForecast/setQuickFiltersDatesFrom", val);
    },
    datesTo(val) {
      this.$store.dispatch("salesForecast/setQuickFiltersDatesTo", val);
    },

    postProgress(val) {
      if (val === 100) {
        this.reload();
      }
    }
  },
  methods: {
    makeFavorite() {
      // this.favorite = !this.favorite
      // this.favoriteRequesting = true
      // this.filtersService
      //   .setSavedFilterFav(this.savedFilter.id, this.favorite ? 1 : 0)
      //   .then(data => {
      //     let filterIndex = this.savedFilters.findIndex(filter => filter.id === this.savedFilter.id)
      //     if (filterIndex >= 0) {
      //       this.savedFilters[filterIndex].favourite = this.favorite
      //     }
      //     this.favoriteRequesting = false
      //   })
      //   .catch(error => {
      //     this.favoriteRequesting = false
      //     this.favorite = !this.favorite
      //     this.$toast.add({
      //       severity: "error",
      //       summary: "Can't change favorite...",
      //       detail: "Error while changing favorite status of this filter.",
      //       life: 5000,
      //     })
      //   })
    },
    resetCols() {
      // this.resettingColumns = true
      // this.filtersService
      //   .resetColumns(this.dbView)
      //   .then(data => {
      //     this.resettingColumns = false
      //     this.columnSelectionDialog = false
      //     this.colSelectedFields = data
      //     this.getDBViewFields()
      //   })
      //   .catch(error => {
      //     this.resettingColumns = false
      //     this.$toast.add({
      //       severity: "error",
      //       summary: "Error",
      //       detail: `Error while reseting columns`,
      //       life: 5000,
      //     })
      //   })
    },
    colUpdated(obj) {
      // if (obj) {
      //   var id = obj.id, width = obj.width
      //   //
      //   let a = this.colSelectedFields.findIndex(b => b.id === id)
      //   if (a >= 0 && this.colSelectedFields[a]) {
      //     this.colSelectedFields[a].width = width
      //   }
      // }
    },
    setupComponent() {
      this.firstRequesting = true;

      // setTimeout(() => {
      //
      //   if (!this.forceReload) {
      // let a = this.$store.getters['customers/getFirstTimeLoad']

      // if (a) {
      //   this.$store.dispatch('customers/setFirstTimeLoad', false)
      //   this.setupComponentData(1)
      // } else {
      //   this.setupComponentData(0)
      // }
      //   }
      // }, 50)

      // this.getUserViewFilters()

      this.getColumnSelection();

      this.getDBViewFields();

      this.setupComponentData(1);
    },
    setupComponentData(hardLoad) {
      if (hardLoad) {
        this.forceReload = true;

        // setup sort

        this.sortField = "";
        this.sortFieldId = 0;
        this.sortOrder = 0;
        // this.$store.dispatch('customers/setSort', {
        //   sortField: this.sortField,
        //   sortFieldId: this.sortFieldId,
        //   sortOrder: this.sortOrder
        // })

        // setup page and rows

        this.rows = 25;
        this.currentPage = 1;
        // this.$store.dispatch('customers/setPage', { page: this.currentPage, rows: this.rows })

        this.realoadLazyTable++;

        // setup search

        this.searchText = "";

        // setup quick filters

        this.quickFiltersSelection = [];
        this.datesFrom = [];
        this.datesTo = [];
        this.$store.dispatch(
          "salesForecast/setMainListQuickFilters",
          this.quickFiltersSelection
        );
        this.$store.dispatch(
          "salesForecast/setQuickFiltersDatesFrom",
          this.datesFrom
        );
        this.$store.dispatch(
          "salesForecast/setQuickFiltersDatesTo",
          this.datesTo
        );

        // setup savedfilter

        // this.getDefUserViewFilter()
        //   .then(savedFilter => {
        //     if (!savedFilter) {
        //       this.getDataFromSource()
        //     } else {
        //       this.savedFilter = savedFilter
        //     }
        //   })
        //   .catch(err => {

        //     this.getDataFromSource()
        //   })
      } else {
        // setup sort

        // if (this.$store.getters['customers/getSortField']) {
        //   this.sortField = this.$store.getters['customers/getSortField']
        //   this.sortFieldId = this.$store.getters['customers/getSortFieldId']
        //   this.sortOrder = this.$store.getters['customers/getSortOrder']
        // }

        // // setup page and rows

        // this.rows = this.$store.getters['customers/getRows']
        // this.currentPage = this.$store.getters['customers/getPage']

        // // setup search

        // this.$route.query.search ? this.searchText = this.$route.query.search : this.searchText = ''

        // // setup quick filters

        this.quickFiltersSelection = [
          ...this.$store.getters["salesForecast/getMainListQuickFilter"]
        ];
        this.datesFrom = [
          ...this.$store.getters["salesForecast/getQuickFiltersDatesFrom"]
        ];
        this.datesTo = [
          ...this.$store.getters["salesForecast/getQuickFiltersDatesTo"]
        ];

        // // setup savedfilter

        // this.savedFilter = {...this.$store.getters['customers/getMainListSavedFilter']}
      }

      this.getDataFromSource();
    },
    getDataFromSource() {
      let savedFilter1 = 0,
        quickFilters = {};

      // if (this.savedFilter && this.savedFilter.id) {
      //   savedFilter1 = this.savedFilter.id
      // }

      var cancelRequest = false;

      //

      if (
        !(
          this.quickFiltersSelection.every(
            element => element === undefined || element === null
          ) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].quickFilter) {
                //

                let a = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].dbField
                  .split(".")
                  .slice(-1)[0];

                if (this.quickFiltersSelection[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Date"
                  ) {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }
                      if (this.datesTo[i]) {
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    //
                    if (this.quickFiltersSelection[i][b] === "Yes") {
                      quickFilters[a] = true;
                    } else if (this.quickFiltersSelection[i][b] === "No") {
                      quickFilters[a] = false;
                    } else if (
                      this.dbViewFieldsForQuickFilters[i].lovEP &&
                      this.dbViewFieldsForQuickFilters[i].lovEP.substr(0, 1) ===
                        "*"
                    ) {
                      quickFilters[a] = this.quickFiltersSelection[i][b];
                    } else {
                      //
                      if (typeof this.quickFiltersSelection[i] === "string") {
                        quickFilters[a] = this.quickFiltersSelection[i];
                      } else {
                        quickFilters[a] = this.quickFiltersSelection[i][
                          this.dbViewFieldsForQuickFilters[i].dbIdField
                        ];
                      }
                    }
                  }
                } else if (
                  !(
                    this.datesFrom[i] === undefined ||
                    this.datesFrom[i] === null ||
                    this.datesTo[i] === undefined ||
                    this.datesTo[i] === null
                  )
                ) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].fieldType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].fieldType === "Number"
                  ) {
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        } else {
          cancelRequest = true;
        }
      }

      var thisMainRequestBody = JSON.stringify(quickFilters);

      let searchQuery = "*";
      if (this.searchText) {
        searchQuery = this.searchText;
      }

      var thisRequest = `${savedFilter1}/${this.currentPage}/${this.rows}/${this.sortFieldId}/${this.sortOrder}/${searchQuery}`;

      if (!cancelRequest) {
        if (
          !(
            thisRequest === this.lastMainRequest &&
            thisMainRequestBody === this.lastMainRequestBody
          ) ||
          this.forceReload
        ) {
          this.forceReload = false;

          this.lastMainRequest = thisRequest;
          this.lastMainRequestBody = thisMainRequestBody;

          this.requesting = true;
          this.customers = [];

          quickFilters.searchText = searchQuery;

          this.salesService
            .getAllSalesForcastByLazyLoad(
              savedFilter1,
              this.currentPage,
              this.rows,
              this.sortFieldId,
              this.sortOrder,
              "*",
              quickFilters
            )
            .then(response => {
              //

              let responseData = JSON.parse(response.config.data),
                a = response.config.url.split("/");

              a[8] = responseData.searchText;

              let b = a.map(c => parseInt(c));

              delete responseData.searchText;
              responseData = JSON.stringify(responseData);

              if (
                a[8] === "*" &&
                this.searchText === "" &&
                b[3] === savedFilter1 &&
                b[4] === this.currentPage &&
                b[5] === this.rows &&
                b[6] === this.sortFieldId &&
                b[7] === this.sortOrder &&
                responseData &&
                responseData === this.lastMainRequestBody
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.customers = response.data;
              } else if (
                b[3] === savedFilter1 &&
                b[4] === this.currentPage &&
                b[5] === this.rows &&
                b[6] === this.sortFieldId &&
                b[7] === this.sortOrder &&
                a[8] === this.searchText &&
                responseData &&
                responseData === this.lastMainRequestBody
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.customers = response.data;
              }
            })
            .catch(err => {
              this.requesting = false;

              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: `Error while getting customer for saved filter ${savedFilter1} and search text ${this.searchText}`,
                life: 5000
              });
            });
        }
      }
    },
    sortChange({ sortField, sortFieldId, sortOrder }) {
      // this.$store.dispatch('customers/setSort', { sortField, sortFieldId, sortOrder })

      this.sortField = sortField;
      this.sortFieldId = sortFieldId;
      this.sortOrder = sortOrder;

      if (this.currentPage !== 1) {
        this.currentPage = 1;
      }

      this.getDataFromSource();
    },
    lazyNext({ page, rows, totalPages }) {
      // this.$store.dispatch('customers/setPage', { page, rows })

      this.rows = rows;
      this.totalPages = totalPages;
      if (this.currentPage !== page) {
        this.currentPage = page;
      }

      this.getDataFromSource();
    },
    setupQuickFilter() {
      this.quickFilterDialog = false;
      //
      this.$store.dispatch(
        "salesForecast/setMainListQuickFilters",
        this.quickFiltersSelection
      );
      this.$store.dispatch(
        "salesForecast/setQuickFiltersDatesFrom",
        this.datesFrom
      );
      this.$store.dispatch(
        "salesForecast/setQuickFiltersDatesTo",
        this.datesTo
      );

      this.getDataFromSource();
    },
    closeSearch() {
      this.searchText = "";
      this.$router.push({ query: { search: "" } });

      this.getDataFromSource();
    },
    updateSearch(e) {
      this.searchText = e;
      this.$router.push({ query: { search: e } });

      this.getDataFromSource();
    },
    checkExistanceOfFilterFldId(quickFilterOptionsList, index) {
      try {
        this.quickFiltersSelection[index] = quickFilterOptionsList.find(
          a =>
            a[this.dbViewFields[index].dbIdField] ===
            this.dbViewFields[index].filterDefId
        );
      } catch (e) {}
    },
    setupViewFieldsForQuickFilters() {
      var duplicateDate = [];

      this.dbViewFields.forEach(d => {
        // if (d.fieldName === "Start Date") {
        //   duplicateDate.push({...d, dbField: "startDateFrom", fieldName: "Start Date From"})
        //   duplicateDate.push({...d, id: d.id + '1', dbField: "startDateTo", fieldName: "Start Date To"})

        // } else {
        duplicateDate.push(d);
        // }
      });

      this.dbViewFieldsForQuickFilters = [];

      var notExists = this.quickFiltersSelection.every(
        element => element === undefined || element === null
      );

      //

      duplicateDate.forEach((d, index) => {
        this.dbViewFieldsForQuickFilters.push(d);

        //

        if (d.quickFilter) {
          if (d.fieldType === "Date") {
            this.filtersService
              .getDateModifiers()
              .then(data => {
                this.quickFiltersOptions[index] = data;
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              })
              .catch(err => {
                // this.$toast.add({
                //   severity: "error",
                //   summary: "Error",
                //   detail: "Error while getting date modifiers",
                //   life: 5000,
                // })
                this.$store.dispatch("addErrorMessage", {
                  severity: "error",
                  content: 'Some data was not loaded from "dateModifiers"'
                });
              });
          } else if (d.lovEP) {
            //
            if (d.lovEP === "YES/NO") {
              this.quickFiltersOptions[index] = [
                { id: 1, [d.dbField]: "Yes" },
                { id: 2, [d.dbField]: "No" }
              ];
              this.checkExistanceOfFilterFldId(
                this.quickFiltersOptions[index],
                index
              );
            } else if (d.lovEP.substr(0, 1) === "*") {
              let list = d.lovEP.substr(1).split("/");
              if (list.length) {
                this.quickFiltersOptions[index] = list.map((a, index) => {
                  return { id: index, [d.dbField]: a };
                });
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              }
            } else {
              this.filtersService
                .filtersCustomRequest(d.lovEP)
                .then(data => {
                  this.quickFiltersOptions[index] = data;
                  this.checkExistanceOfFilterFldId(
                    this.quickFiltersOptions[index],
                    index
                  );
                })
                .catch(err => {
                  if (err && err.response && err.response.status !== 200) {
                    // this.$toast.add({
                    //   severity: "error",
                    //   summary: "Error",
                    //   detail: "Error while getting quick filters",
                    //   life: 5000,
                    // })
                    this.$store.dispatch("addErrorMessage", {
                      severity: "error",
                      content: `Some data was not loaded from "${d.lovEP}"`
                    });
                  }
                });
            }
          }
        }
        if (notExists) {
          this.quickFiltersSelection.push(null);
        }
        this.quickFiltersOptions.push({});
        //
      });

      //
      //
    },
    getDefUserViewFilter() {
      // return new Promise(async (resolve, reject) => {
      //   this.filtersService
      //     .getDefUserViewFilter(this.dbView)
      //     .then(data => resolve(data))
      //     .catch(err => {
      //       this.savedFilter = {}
      //       // this.$toast.add({
      //       //   severity: "error",
      //       //   summary: "Error",
      //       //   detail: "Error while getting default user view filter.",
      //       //   life: 5000,
      //       // })
      //       this.$store.dispatch('addErrorMessage', {
      //         severity: 'error',
      //         content: 'Some data was not loaded from "defUserViewFilter/{dbView}"'
      //       })
      //       reject()
      //     })
      // })
    },
    getUserViewFiltersByHard() {
      // this.filtersService
      //   .getUserViewFiltersByHard(this.dbView)
      //   .then((data) => {
      //     //
      //     let obj = {...this.savedFilter}
      //     this.savedFilters = data;
      //     if (obj && obj.id) {
      //       this.savedFilter = data.find(a => {
      //         if (a && a.id === obj.id) {
      //           return true
      //         }
      //       })
      //     }
      //   })
      //   .catch(err => {
      //     // this.$toast.add({
      //     //   severity: "error",
      //     //   summary: "Error",
      //     //   detail: "Error while getting customer user filters",
      //     //   life: 5000,
      //     // })
      //     this.$store.dispatch('addErrorMessage', {
      //       severity: 'error',
      //       content: 'Some data was not loaded from "userViewFilters/{dbView}"'
      //     })
      //   })
    },
    getUserViewFilters() {
      // this.filtersService
      //   .getUserViewFilters(this.dbView)
      //   .then((data) => {
      //     //
      //     this.savedFilters = data;
      //   })
      //   .catch(err => {
      //     // this.$toast.add({
      //     //   severity: "error",
      //     //   summary: "Error",
      //     //   detail: "Error while getting customer user filters",
      //     //   life: 5000,
      //     // })
      //     this.$store.dispatch('addErrorMessage', {
      //       severity: 'error',
      //       content: 'Some data was not loaded from "userViewFilters/{dbView}"'
      //     })
      //   })
    },
    setupColumns() {
      if (
        this.colSelectedFields &&
        this.colSelectedFields[0] &&
        this.columnSelectionDialog
      ) {
        this.reloadColumnSelectionComponent++;
      }

      let a = [];
      this.colSelectedFields.forEach(b => {
        //
        let c = a.find(d => d.dbField === b.dbField.dbField);
        //
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = {
            ...b.dbField,
            defWidth: b.width
          };
        }
      });

      if (a.length) {
        this.colSelectedFieldsForTable = a;
      }
    },
    getColumnSelectionByHard() {
      // this.filtersService
      //   .getColumnSelectionByHard(this.dbView)
      //   .then(data => {
      //     this.colSelectedFields = data
      //   })
      //   .catch(err => {
      //     if (err.response.status === 500) {
      //       // Default view
      //       this.defaultView = true
      //     }
      //     // this.$toast.add({
      //     //   severity: "error",
      //     //   summary: "Error",
      //     //   detail: "Error while column selection",
      //     //   life: 5000,
      //     // })
      //     this.$store.dispatch('addErrorMessage', {
      //       severity: 'error',
      //       content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
      //     })
      //   })
    },
    getColumnSelection() {
      this.filtersService
        .getColumnSelection(this.dbView)
        .then(data => {
          this.colSelectedFields = data;
        })
        .catch(err => {
          if (err.response.status === 500) {
            // Default view

            this.defaultView = true;
          }

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "currentUserViewFields/{dbView}"'
          });
        });
    },
    getDBViewFields() {
      this.filtersService
        .getDBViewFields(this.dbView)
        .then(data => (this.dbViewFields = data))
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          });
        });
    },
    isEmpty() {
      //
      return !(
        this.quickFiltersSelection.every(
          element => element === undefined || element === null
        ) &&
        this.datesFrom.every(
          element => element === undefined || element === null
        ) &&
        this.datesTo.every(element => element === undefined || element === null)
      );
    },
    getBadgeForQuickFilters() {
      //
      let count = 0;
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        if (
          this.quickFiltersSelection[i] ||
          this.datesFrom[i] ||
          this.datesTo[i] ||
          this.datesFrom[i] === 0 ||
          this.datesTo[i] === 0
        ) {
          count++;
        }
      }
      //
      return count;
    },
    getClassForQuickFiltersButon() {
      if (this.isEmpty()) {
        return "p-button-success";
      } else {
        return "p-button-info";
      }
    },
    getClassForQuickFiltersDiv() {
      if (this.isEmpty()) {
        return "greenBackground";
      } else {
        return "defaultBackground";
      }
    },
    isQuickFilterable(index) {
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].quickFilter
        ? this.dbViewFieldsForQuickFilters[index].quickFilter
        : false;
    },
    getFieldType(index) {
      //
      //
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].fieldType
        ? this.dbViewFieldsForQuickFilters[index].fieldType
        : "";
    },
    setSelection({ value, index }) {
      this.quickFiltersSelection[index] = value;
    },
    useAutoComplete(index) {
      //
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterAutocomplete
        : false;
    },
    showDropdown(index) {
      //
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterDropdown
        : false;
    },
    isForceSelection(index) {
      return this.dbViewFieldsForQuickFilters[index]
        ? !this.dbViewFieldsForQuickFilters[index].filterAllowStartWith
        : false;
    },
    getOptions(index) {
      return Array.isArray(this.quickFiltersOptions[index])
        ? this.quickFiltersOptions[index]
        : [];
    },
    getDataKey(data) {
      return data ? data.dbIdField : null;
    },
    getOptionLabel(data, index) {
      //
      let a = data ? data.dbField : "",
        b = this.getOptions(index);
      //
      if (b && b[0] && b[0][data.dbNameField]) {
        a = data ? data.dbNameField : "";
        return a;
      } else {
        a = data ? data.dbField.split(".").slice(-1) : "";
        return a[0];
      }
    },
    showDateRanges(index) {
      //
      if (
        this.quickFiltersSelection[index] &&
        this.quickFiltersSelection[index].dateModifierFunc === "custom"
      ) {
        return true;
      } else {
        return false;
      }
    },
    clearQuickFiltersSelections() {
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        this.quickFiltersSelection[i] = null;
        this.datesFrom[i] = null;
        this.datesTo[i] = null;
      }
      this.quickFiltersDivKey++;
    },
    clearQuickFilter() {
      this.quickFilterDialog = false;
      this.clearQuickFiltersSelections();

      this.getDataFromSource();
    },
    editSelectedFilter() {
      // this.filterToEdit = {...this.savedFilter}
      // this.filterFormDialog = true
    },
    newFilter() {
      // this.filterToEdit = {}
      // this.filterFormDialog = true
    },
    reload() {
      this.forceReload = true;
      this.setupComponentData(0);
    },
    updateDefaultFilter() {
      // this.filtersService
      //   .getDefUserViewFilterByHard(this.dbView)
      //   .then(data => {
      //   })
      //   .catch(error => {
      //     // this.$toast.add({
      //     //   severity: "error",
      //     //   summary: "Error",
      //     //   detail: "Error while updating default filter.",
      //     //   life: 5000,
      //     // })
      //     this.$store.dispatch('addErrorMessage', {
      //       severity: 'error',
      //       content: 'Some data was not loaded from "defUserViewFilter/{dbView}"'
      //     })
      //   })
    },
    filterSaved() {
      // this.filterFormDialog = false
      // this.getUserViewFiltersByHard()
      // this.updateDefaultFilter()
      // this.filterToEdit = {}
      // this.setupComponentData(0)
    },
    colSaved() {
      // this.columnSelectionDialog = false
      // this.getColumnSelectionByHard()
      // this.getDBViewFields()
    },
    openColumnsSelection() {
      // this.columnSelectionDialog = true
      // this.reloadColumnSelectionComponent++
    },
    editCustomer(customer) {
      // this.customer = { ...customer };
      // this.disabledArr = ['country']
      // this.customerDialog = true;
    },
    openNew() {
      // this.customer = {};
      // this.disabledArr = ['keyContact', 'country']
      // this.customerDialog = true
    },
    saved({ customer, duplicates }) {
      // this.customerDialog = false;
      // this.customer = {}
      // if (duplicates && duplicates.length) {
      //   this.duplicates = duplicates;
      //   this.customer = customer
      //   this.displayDuplicateMessage = true
      // } else {
      //   this.customers.push(customer)
      //   this.reload()
      // }
    },
    sendDuplicate() {
      // customerConf(this, 'Customers.vue')
    },
    deleteSavedFilter() {
      // if (this.savedFilter && this.savedFilter.id) {
      //   this.deleteRequesting = true
      //   this.filtersService
      //     .deleteFilter(this.savedFilter.id)
      //     .then(data => {
      //       this.deleteRequesting = false
      //       this.deleteSavedFilterWarning = false
      //       this.getUserViewFiltersByHard()
      //     })
      //     .catch(error => {
      //       this.deleteRequesting = false
      //       this.$toast.add({
      //         severity: "error",
      //         summary: "Unable to delete.",
      //         detail: "Got some error while deleting this filter.",
      //         life: 5000,
      //       })
      //     })
      // } else {
      //   this.$toast.add({
      //     severity: "warn",
      //     summary: "A filter is required",
      //     detail: "Please select a saved filter first.",
      //     life: 5000,
      //   })
      // }
    },
    excelToJSON(file) {
      readXlsxFile(file).then(rows => {
        if (rows && rows.length) {
          if (rows[1] && !rows[1][1]) {
            rows = rows.filter((_, index) => index !== 1);
          }

          this.$store.dispatch("salesForecast/deleteSales", {
            that: this,
            rows
          });
          this.postingInfo = true;
        }
      });
    },
    onFileSelect(e) {
      if (e.target.files && e.target.files[0]) {
        if (e.target.files[0].size < 5000000) {
          if (
            e.target.files[0].name &&
            e.target.files[0].name.toLowerCase() &&
            e.target.files[0].name.toLowerCase().includes("forecast")
          ) {
            this.excelToJSON(e.target.files[0]);
            e.target.value = null;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Wrong file.",
              detail: "Don't think its a forecast data file.",
              life: 5000
            });
          }
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Big file",
            detail: "File size is greater than 1MB.",
            life: 5000
          });
        }
      }
    },
    setSelectedRows(rows) {
      this.selectedRows = rows;
    },
    deleteRecordsConfirmation() {
      if (this.selectedRows && this.selectedRows.length) {
        this.deleteRecordWarning = true;
      }
    },
    deleteRecords() {
      this.deleteRecordWarning = false;

      for (let i = 0; i < this.selectedRows.length; i++) {
        if (this.selectedRows[i] && this.selectedRows[i].id) {
          this.salesService
            .deleteSalesForecast(this.selectedRows[i].id)
            .then(() => {
              if (i === this.selectedRows.length - 1) {
                this.setupComponentData(1);
              }

              this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Record deleted.",
                life: 5000
              });
            })
            .catch(error => {
              this.$toast.add({
                severity: "error",
                summary: "Failure",
                detail: "Unable to delete record.",
                life: 5000
              });
            });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.greenBackground {
  background-color: #5c9434;
  width: 83px;
}

.defaultBackground {
  // background-color: #2494f4;
  background-color: #248cc4;
  width: 50px;
}
</style>
